import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Heading, Text, Ol, Li } from '../SubComponents/Text';
import { Button } from '../SubComponents/Buttons';
import useLocalize from '../Hooks/useLocalize';
import useLocale from '../Hooks/use-locale';
import localizations from '../localizations';

const QuestionWrapper = styled.div`
  margin-bottom: 16px;
`;

const FaqButton = styled(Button)`
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

interface GiftcardFAQProps {
  heading: string;
  instructions?: string;
  giftcardValidity?: number;
  vouchers: any[];
  faq?: boolean;
  questions?: { question: string; answer: string }[];
}

const GiftcardFAQ = (props: GiftcardFAQProps) => {
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];
  const localize = useLocalize();

  const [showFaq, setShowFaq] = useState(false);

  const validity = props.giftcardValidity ?? 36;
  const defaultGiftcardText = `${localize('faq.p1')} ${validity} ${localize('faq.p2')}`;

  return (
    <>
      <Heading>{props.heading}</Heading>

      {props.instructions ? (
        <Text mb="3" renderWhiteSpace mt="3">
          {props.instructions}
        </Text>
      ) : (
        <>
          <Ol p="2">
            {localization.faqList &&
              localization.faqList.map((listItem, index) => (
                <Li key={index} my="1">
                  {listItem}
                </Li>
              ))}
          </Ol>
          <Text mb="3">
            {props.vouchers.length > 0 ? localize('faq.campaign') : defaultGiftcardText}
          </Text>
        </>
      )}

      {props.faq && (
        <FaqButton mb="3" onClick={() => setShowFaq(!showFaq)}>
          {showFaq ? localize('faq.hide') : localize('faq.show')}
        </FaqButton>
      )}

      {showFaq &&
        props.questions &&
        props.questions.map(({ question, answer }, index) => (
          <QuestionWrapper key={index}>
            <Text bold>{question}</Text>
            <Text>- {answer}</Text>
          </QuestionWrapper>
        ))}
    </>
  );
};

export default GiftcardFAQ;
